import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

// 人员管理
const moduleName = "personManagement";

store.registerModule(moduleName, {
  namespaced: true,
  state: {},
  actions: {
    //分页查询员工(本地)
    async getUserPage({ commit }, payload) {
      var result = await api.get(
        `/api/User/Page?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //删除员工
    async deleteUser({ commit }, payload) {
      var result = await api.delete(`/api/User/${payload}`);
      return result.data;
    },
    async addUser({ commit }, payload) {
      var result = await api.post(`/api/User/`, payload);
      return result.data;
    },
    // 校验手机号是否已在企联网注册（新增员工）
    async checkUserLoginPhone({ commit }, phone) {
      var result = await api.get(`/api/User/CheckLoginPhone`, {
        params: { phone }
      });
      return result.data;
    },
    // 删除用户和员工
    async deleteUserAndEmployee({ commit }, payload) {
      var result = await api.post(`/api/User/DeleteUserAndEmployee`, payload);
      return result.data;
    },
    // 查询编辑员工视图
    async getUserView({ commit }, payload) {
      var result = await api.get(`/api/User/${payload}`);
      return result.data;
    },
    // 修改员工
    async editUser({ commit }, payload) {
      var result = await api.put(`/api/User/`, payload);
      return result.data;
    },
    // 获取部门列表或职位列表
    async getDepartment({ commit }, payload) {
      var result = await api.get(`/api/User/GetDepartment?pid=${payload}`);
      return result.data;
    },
    //获取用户员工分页列表
    async getUserEmployee({ commit }, payload) {
      var result = await api.get(
        `/api/User/GetUserEmployee?${queryString.stringify(payload)}`
      );
      return result.data;
    }
  },
  mutations: {}
});

export default moduleName;
